import { render } from "./addRoute.vue?vue&type=template&id=53829fb5"
import script from "./addRoute.vue?vue&type=script&lang=js"
export * from "./addRoute.vue?vue&type=script&lang=js"

import "./addRoute.vue?vue&type=style&index=0&id=53829fb5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__